import { createAction, props } from '@ngrx/store';
import { ActionCreator, TypedAction } from '@ngrx/store/src/models';
import { ScanMode } from '../models';

export enum ScannerActionTypes {
  ShowScannerCamera = '[Scanner] ShowScannerCamera',
  ShowTemporaryClosedScannerCamera = '[Scanner] ShowTemporaryClosedScannerCamera',
  CloseScannerCamera = '[Scanner] CloseScannerCamera',
  CloseIfScannerIsShown = '[Scanner] CloseIfScannerIsShown',
  CloseScannerCameraSuccess = '[Scanner] CloseScannerCameraSuccess',
  StartScaning = '[Scanner] StartScanning',
  StartScanningSuccess = '[Scanner] StartScanningSuccess',
  PauseScanning = '[Scanner] PauseScanning',
  PauseScanninguccess = '[Scanner] PauseScanningSuccess',
  ResumeScanning = '[Scanner] ResumeScanning',
  ResumeScanningSuccess = '[Scanner] ResumeScanningSuccess',
  StopScanning = '[Scanner] StopeScanning',
  StopScanningSuccess = '[Scanner] StopScanningSuccess',
  RestartScanning = '[Scanner] RestartScanner',
  RestartScanningSuccess = '[Scanner] RestartScanningSuccess',
  ScannerStateChanged = '[Scanner] ScannerStateChanged',
  ChangeScannerCameraSize = '[Scanner] ChangeScannerCameraSize',
  BarcodeScanned = '[Scanner] BarcodeScanned',
}

export const showScannerCameraAction = createAction(
  ScannerActionTypes.ShowScannerCamera,
  props<{
    scanMode: ScanMode;
    actionToDispatchOnBarcodeScanned: ActionCreator<string, BarcodeScannedAction>;
  }>()
);
export const showTemporaryClosedScannerCameraAction = createAction(ScannerActionTypes.ShowTemporaryClosedScannerCamera);
export const closeScannerCameraAction = createAction(ScannerActionTypes.CloseScannerCamera, props<{ isTemporaryClosed: boolean }>());
export const closeIfScannerIsShownAction = createAction(ScannerActionTypes.CloseIfScannerIsShown);
export const closeScannerCameraSuccessAction = createAction(ScannerActionTypes.CloseScannerCameraSuccess);

export const startScanningAction = createAction(ScannerActionTypes.StartScaning);
export const startScanningSuccessAction = createAction(ScannerActionTypes.StartScanningSuccess);
export const pauseScanningAction = createAction(ScannerActionTypes.PauseScanning);
export const pauseScanningSuccessAction = createAction(ScannerActionTypes.PauseScanninguccess);
export const resumeScanningAction = createAction(ScannerActionTypes.ResumeScanning);
export const resumeScanningSuccessAction = createAction(ScannerActionTypes.ResumeScanningSuccess);
export const stopScanningAction = createAction(ScannerActionTypes.StopScanning);
export const stopScanningSuccessAction = createAction(ScannerActionTypes.StopScanningSuccess);
export const restartScanningAction = createAction(ScannerActionTypes.RestartScanning);
export const restartScanningSuccessAction = createAction(ScannerActionTypes.RestartScanningSuccess);

export const scannerStateChangedAction = createAction(
  ScannerActionTypes.ScannerStateChanged,
  props<{ scannerState: Scandit.BarcodePicker.State }>()
);
export const changeScannerCameraSizeAction = createAction(ScannerActionTypes.ChangeScannerCameraSize);
export const barcodeScannedAction = createAction(ScannerActionTypes.BarcodeScanned, props<{ barcode: string }>());

export type BarcodeScannedAction = ActionCreator<string, (props: { barcode: string }) => { barcode: string } & TypedAction<string>>;
